import React from "react";
import "../../Styles/ModalCS.css";

const ModalCS = ({img, title,time,text}) => {
    return (
        <div className="Bashgah-modal-CS">
            <div className="Bashgah-modal-inside-CS">
                <div className="Bashgah-modal-inside-CS-top">
                    <div className="Bashgah-modal-inside-CS-top-image">
                        <img className="Bashgah-modal-inside-CS-top-image-img" src={img} />
                    </div>
                    <p className="Bashgah-modal-inside-CS-top-text number-font">
                      {title}
                    </p>
                    <p className="Bashgah-modal-inside-CS-top-time number-font">
                        {time}
                    </p>

                </div>

                <div className="Bashgah-modal-inside-CS-bottom">
                    <p className="Bashgah-modal-inside-CS-bottom-text">
                       {text}
                    </p>
                </div>

            </div>

        </div>
    )
}

export default ModalCS;